import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

export const GetMeshProjects = graphql(/* GraphQL */ `
  query MeshProjects($accountId: BigInt!, $projectId: BigInt) {
    account(id: $accountId) {
      meshProjects(filter: { projectId: $projectId }) {
        dbtCloudProject
        dbtCoreProject
        projectId
        defaultEnvironmentId
        dependentProjects {
          dbtCloudProject
          dbtCoreProject
          projectId
          defaultEnvironmentId
        }
        isConsumer
        isProducer
        projectSummary {
          publicModels
        }
      }
    }
  }
`);
type MeshProjectProps = {
  accountId: number | undefined;
  projectId?: number | null;
  pause?: boolean;
};

export const useMeshProjects = ({
  accountId = 0,
  projectId = null,
  pause,
}: MeshProjectProps) => {
  const query = useQueryStable({
    query: GetMeshProjects,
    variables: { accountId, projectId },
    pause: pause || !accountId,
  });

  // TODO: we need a cachebusting strategy for Account-level queries

  return query;
};
